import React, { ReactElement } from 'react';
import { Tooltip as MuiTooltip } from '@mui/material';

interface Props {
  title?: string;
  children: ReactElement;
}

export default function RestrictedTooltip({ title, children }: Props) {
  if (!title) {
    return children;
  }

  return (
    <MuiTooltip
      title={title}
      placement="top"
      arrow
      enterTouchDelay={500}
      leaveTouchDelay={3000}
      classes={{
        popper: '!z-[5000]',
        tooltip: '!bg-white !text-brand-text-primary !text-xs !font-normal !border !shadow !rounded-md !px-sm !py-2xs',
        arrow: '!text-white',
      }}
    >
      {children}
    </MuiTooltip>
  );
}
